module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/154.d1ca1e00.png";